module.exports = __webpack_public_path__ + "img/man_preg_lady.86b2e236.svg";